<router-outlet></router-outlet>

<div *ngIf="version" class="version">
  {{ version }}
</div>
